<template>
  <div>
    <message :messages="messages"></message>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <premium-shared></premium-shared>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" dark type="submit" :loading="quotation.saving" @click.prevent="doInForceProposal" :disabled="premiumInfo.init !== 1" v-if="checkAccess(['cargoQuoteRef'])">
        In-Force Proposal
        <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
      </v-btn>
      <v-btn color="primary" type="submit" :loading="quotation.saving" @click.prevent="doApproveQuote" :disabled="premiumInfo.init !== 1" v-if="checkAccess(['cargoQuoteRef'])">
        Approve Quotation
        <v-icon right dark>mdi-check</v-icon>
      </v-btn>
      <v-btn color="primary" type="submit" :loading="quotation.saving" @click.prevent="doSendForRef" :disabled="premiumInfo.init !== 1" v-else>
        Send for Review
        <v-icon right dark>mdi-account-check</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_CARGO_PREMIUM, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_LEAVEQUOTE, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import PremiumShared from './PremiumShared'
import { generalCargoForm } from '@/store/modules/agency/actions/quote'

export default {
  data() {
    return {
      labels: {
        premium: 'Premium Summary'
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    premiumInfo() {
      return this.quotation.commonInfo.premium
    }
  },
  methods: {
    doCalculate() {
      this.$store.dispatch('cargoQuoteCalculate')
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
      this.$router.push({ name: 'cargoQuoteInsured' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_CARGO_PREMIUM, this.cargoForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    doInForceProposal() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_PREMIUM, this.cargoForm)
          this.processInForce()
        }
      })
    },
    doApproveQuote() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_PREMIUM, this.cargoForm)
          this.processApprove()
        }
      })
    },
    async processInForce() {
      const apiUrl = this.quotation.menu.proceedQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))

          // After success push to query page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: true
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has converted to In-Forced Proposal')
          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo }, query: { if: true } })
        } catch (err) {
          this.promptFieldCheck()
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async processApprove() {
      const apiUrl = this.quotation.menu.approveQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))

          // After success push to query page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: true
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been approved')

          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSendForRef() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_PREMIUM, this.cargoForm)
          this.sendForRef()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async sendForRef() {
      const apiUrl = this.quotation.menu.refQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))

          // After success push to proposal page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: true
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been submitted for review')

          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          this.promptFieldCheck()
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 5) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
    }
  },
  mounted() {
    this.doCalculate()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  components: {
    PremiumShared
  }
}
</script>

<style lang="scss">

</style>
